import polyglotI18nProvider from "ra-i18n-polyglot";
import fr from "./fr";
import en from "./en";

export const i18nProvider = polyglotI18nProvider((langCode) => {
    if (langCode && langCode !== "fr") return en;
    return fr;
}, "fr");
